// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__FvBGg","outlined":"Button_outlined__1PzJu","fullWidth":"Button_fullWidth__YEHgd","disabled":"Button_disabled__3p75m"};